// reduxjs toolkit
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../service/API/base_url";
import { handleSuccess, handleError } from "../../utils/toast";

const handleApiResponse = (response, thunkAPI, successMessage) => {
  if (response.status === 200 || response.status === 201) {
    if (successMessage) handleSuccess(successMessage);
    return response.data;
  } else {
    handleError(response.message);
    return thunkAPI.rejectWithValue(response.data);
  }
};

const handleApiError = (error, thunkAPI, errorMessage) => {
  handleError(error.response?.data?.message || errorMessage);
  return thunkAPI.rejectWithValue(error.response?.data);
};

// List only approved Resources
export const approvedResourceList = createAsyncThunk(
  "resources",
  async (types, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}born-to-win-api/get-resources/types/`,
        {
          params: { types },
        }
      );
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "loading...");
    }
  }
);

// List all Resources
export const viewResource = createAsyncThunk(
  "resources",
  async (category, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BaseUrl}born-to-win-api/resources-types/category/`,
        {
          params: { category }, // Adds ?applicationType=YourValue
        }
      );
      return handleApiResponse(response, thunkAPI);
    } catch (e) {
      return handleApiError(e, thunkAPI, "loading...");
    }
  }
);
